import { render, staticRenderFns } from "./BulkOrderCreate.vue?vue&type=template&id=69645534&"
import script from "./BulkOrderCreate.vue?vue&type=script&lang=js&"
export * from "./BulkOrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./BulkOrderCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports